import { defineComponent as p, computed as n, openBlock as h, createElementBlock as f, normalizeClass as u, createElementVNode as s, Fragment as k, createTextVNode as C, toDisplayString as V, renderSlot as S } from "vue";
import { a as $ } from "../../../vee-validate.esm-c4518011.js";
import { U as c } from "../../../constants-69d32a0e.js";
import { _ as E } from "../../../_plugin-vue_export-helper-dad06003.js";
const A = p({
  name: "VFormRadioCheckbox",
  emits: [c, "change"],
  inheritAttrs: !1,
  props: {
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    labelSize: {
      type: String,
      default: "m"
    },
    type: {
      type: String,
      default: "radio"
    },
    modelValue: {
      type: [String, Boolean, Array],
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    rules: {
      type: Function,
      default: () => !0
    },
    highlightError: {
      type: Boolean,
      default: !0
    }
  },
  setup(e, a) {
    const l = {
      uncheckedValue: "",
      validateOnMount: !1
    }, { errorMessage: i, checked: m, handleChange: t } = $(
      e.name,
      e.rules,
      {
        validateOnMount: l.validateOnMount,
        uncheckedValue: l.uncheckedValue,
        type: e.type,
        valueProp: e.value
      }
    );
    t(e.modelValue);
    const o = (d) => {
      let r = d.target.value;
      d.target.checked || (r = ""), t(r), a.emit(c, r), a.emit("change", d);
    }, y = n(() => !!i && i.value !== void 0), b = n(() => `hobi-input--${e.type}`), g = n(() => `hobi-label--${e.type} owbd-label--${e.labelSize}`), v = n(() => Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.modelValue === e.value);
    return {
      isInvalid: y,
      fieldClass: b,
      labelClass: g,
      config: l,
      handleChange: t,
      onChange: o,
      checked: m,
      isChecked: v
    };
  }
});
const F = ["for"], _ = ["type", "id", "name", "value", "v-model", "checked", "aria-describedby", "data-testid"];
function M(e, a, l, i, m, t) {
  return h(), f("div", {
    class: u(["hobi-form-input-field tw-inline-flex", e.isInvalid && e.highlightError ? "hobi-form-field--invalid" : ""])
  }, [
    s("label", { for: e.id }, [
      s("input", {
        type: e.type,
        id: e.id,
        name: e.name,
        value: e.value,
        "v-model": e.modelValue,
        checked: e.isChecked,
        class: u(["hobi-visually-hidden hobi-input", e.fieldClass]),
        "aria-describedby": `hobi-${e.name}-error-message`,
        "data-testid": e.name,
        onChange: a[0] || (a[0] = (...o) => e.onChange && e.onChange(...o))
      }, null, 42, _),
      s("p", {
        class: u(["hobi-label", e.labelClass])
      }, [
        e.label ? (h(), f(k, { key: 0 }, [
          C(V(e.label), 1)
        ], 64)) : S(e.$slots, "default", { key: 1 }, void 0, !0)
      ], 2)
    ], 8, F)
  ], 2);
}
const I = /* @__PURE__ */ E(A, [["render", M], ["__scopeId", "data-v-0daa186f"]]);
export {
  I as default
};
